/**
 * Created by Jaime Bonilla Venegas on 2017-06-19.
 *
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { Item } from './components';
import Form from '../../forms';
import * as actions from './actions';
import { SubHeader, EmptyList } from '../../components/layout';
import { ProveedoresFilter } from '../../components/filters';
import { serializeParams } from '../../common/helpers';
import Snackbar from 'material-ui/Snackbar';
import { getPagePermissions, SUPPLIERS_PERMISSION } from '../../security/permissions';

class Proveedores extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showErrors: false,
            validationErrors: {}
        }
    }

    componentWillMount() {
        this.props.fetchData('suppliers', 'suppliers', 'suppliers', { projection: 'denormalizedSupplier', sort: 'name' });
    }

    CreateURL(table, filter, projection) {

        if (filter.includes("street")) { filter = filter.replace("street", "address.street"); }
        if (filter.includes("externalNumber")) { filter = filter.replace("externalNumber", "address.externalNumber"); }
        if (filter.includes("internalNumber")) { filter = filter.replace("internalNumber", "address.internalNumber"); }
        if (filter.includes("zipCode")) { filter = filter.replace("zipCode", "address.zipCode"); }
        if (filter.includes("colony")) { filter = filter.replace("colony", "address.colony"); }
        if (filter.includes("city")) { filter = filter.replace("city", "address.city"); }
        if (filter.includes("municipality")) { filter = filter.replace("municipality", "address.municipality"); }
        if (filter.includes("state")) { filter = filter.replace("state", "address.state"); }
        if (filter.includes("country")) { filter = filter.replace("country", "address.country"); }

        return (table.concat(filter).concat(projection));
    }

    formHandler(open, path, form) {
        this.props.notify({ op: 'update', path, value: open });
        switch (path) {
            case 'NEW_SUPPLIER':
                this.props.saveSupplier(form);
                break;
            default:
        }
    }

    render() {
        const {
          formOpen,
            suppliers,
            notify,
            isLoading,
            executiveUsers,
            activePage,
            numPages,
            showNotification,
            showMessage,
            notificationColor,
            pagePermissions
        } = this.props;

        return (
            <div>
                <SubHeader
                    showRefresh={isLoading}
                    title="Proveedores"
                    onPressHeaderButton={() => this.formHandler(true, 'formOpen')}
                    showAddButton={pagePermissions.create}
                    paginationConfig={{
                        numPages,
                        activePage,
                        notify: (page) => {
                            this.props.fetchData('suppliers', 'suppliers', 'suppliers', { projection: 'denormalizedSupplier', sort: 'name', page });
                        }
                    }}
                />
                <div className="navbar visible-xs" style={{ padding: '0rem 2.3rem' }}>
                    <button
                        className="btn btn-default navbar-btn btn-filtros"
                        data-toggle="collapse"
                        data-target="#filter-sidebar"
                    >
                        <i className="fa fa-tasks" /> Panel de filtros
                    </button>
                </div>
                <div>
                    <ProveedoresFilter
                        onSearch={(params) => {
                            delete params.supplierText;
                            Object.keys(params).forEach(key => params[key] === "" ? delete params[key] : '');
                            const concat = isEmpty(params) ? '?' : '&';
                            this.props.fetchData('suppliers', 'suppliers', this.CreateURL('suppliers', serializeParams(params), `${concat}projection=denormalizedSupplier`))
                        }}
                        onClear={(params) => {
                            this.props.fetchData('suppliers', 'suppliers', 'suppliers', { projection: 'denormalizedSupplier', sort: 'name' });
                        }}
                    >
                        {
                            suppliers.length === 0 ? <EmptyList /> :
                            suppliers.map((supplier, index) => {
                                return (
                                    <Item
                                        key={index}
                                        supplier={supplier}
                                        allowUpdate={pagePermissions.update}
                                        allowDelete={pagePermissions.delete}
                                        onOpenInfoModal={() => notify({ op: 'update', path: 'tabuladorFormOpen', value: true })}
                                        executiveUsersList={executiveUsers.items}
                                        actions={{
                                            deleteSupplier: (value) => {
                                                this.props.deleteSupplier(value, index);
                                            }
                                        }}
                                        onSave={(newSupplier) => {
                                            //This is only updating the item on memory
                                            //Replace this with the action that saves results on server
                                            this.props.editSupplier(newSupplier, index);
                                        }}
                                    />
                                );
                            })
                        }
                    </ProveedoresFilter>
                </div>
                <Form
                    title="Nuevo Proveedor"
                    type="proveedor"
                    open={formOpen}
                    actions={{}}
                    onModalClosed={() => this.formHandler(false, 'formOpen')}
                    onSave={(form) => {
                        console.log('Form notifies until the form is valid', form);
                        this.formHandler(false, 'NEW_SUPPLIER', form);
                    }}//Will return if form is valid to send it
                />

                <Snackbar
                    bodyStyle={{
                        top: 0,
                        bottom: 'auto',
                        backgroundColor: notificationColor,
                        maxWidth: "800px",
                        height: "55px",
                        lineHeight: "28px",
                        left: (window.innerWidth - 288) / 2,
                        /*transform: this.props.errorMessage ?
                          'translate3d(0, 0, 0)' :
                          "translate3d(0, "+ -(window.innerHeight - 100) + "px , 0)"*/
                    }}
                    open={showNotification}
                    message={showMessage}
                    autoHideDuration={4000}
                    onRequestClose={() => this.props.notify({ op: 'update', path: 'showNotification', value: false })}
                />
            </div >
        );
    }
}

const mapStateToProps = ({ suppliersState, userData, userData: { permissions } }) => {
    return {
        ...suppliersState,
        userData,
        pagePermissions: getPagePermissions(SUPPLIERS_PERMISSION, permissions)
    };
};

export default connect(mapStateToProps, { ...actions })(Proveedores);



// WEBPACK FOOTER //
// ./containers/proveedores/index.js